import $ from 'jquery';

export default function blockManifest() {
  $('[aria-controls="manifest-complete-accordion"]').click(function () {
    let getText = $(this).html();

    if (getText == 'Alles anzeigen') {
      $(this).html('Weniger anzeigen');
    } else {
      $(this).html('Alles anzeigen');
    }

    $('#manifest-complete-accordion').slideToggle();
    $('#manifest-complete').fadeToggle();
  });
}
